export default __webpack_public_path__ + "static/media/card-bg-img-2.c14fe0e7.svg";